<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-08 10:12:47
 * @LastEditTime: 2019-11-19 21:46:19
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="researchList" v-if="show_flg">
    <div class="header">
      <a
        href="http://mp.weixin.qq.com/s?__biz=Mzg2ODIxNjAxNQ==&mid=100000002&idx=1&sn=ba49583c85b8e69d032b4d507e714d41&chksm=4eaefca279d975b4e7a5a1ade4ff65dbb2e8972fc8eefa6ab45ffbfa6b070978373eb947e31c#rd"
      >
        <img src="../assets/head.jpeg">
      </a>
    </div>

    <div class="body" >
      <div class="title">
        <van-row class="title_title">第二阶段问卷调研</van-row>
        <van-row class="title_date">调研时间: 12月25日 - 1月10日</van-row>
      </div>
      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon2">
              <img src="../assets/true2.jpg">
            </van-col>
            <van-col span="12" class="list_title">观念问卷1</van-col>
            <van-col v-show="q1_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q1_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(1)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon2">
              <img src="../assets/true2.jpg">
            </van-col>
            <van-col span="12" class="list_title">观念问卷2</van-col>
            <van-col v-show="q2_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q2_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(2)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>

      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon circle">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷1</van-col>
            <van-col v-show="q3_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q3_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(3)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>

      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷2</van-col>
             <van-col v-show="q4_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q4_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(4)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>

      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷3</van-col>
           <van-col v-show="q5_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q5_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(5)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷4</van-col>
             <van-col v-show="q6_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q6_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(6)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷5</van-col>
             <van-col v-show="q7_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q7_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(7)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="list-wai">
        <div class="list background-color-1">
          <van-row>
            <van-col span="4" class="list_icon">
              <img src="../assets/timg.jpg">
            </van-col>
            <van-col span="12" class="list_title">行为问卷6</van-col>
             <van-col v-show="q8_show" class="list_status_go">
              <van-button type="default" round>已完成</van-button>
            </van-col>
            <van-col v-show="!q8_show" class="list_status_go">
              <van-button type="info" round @click="goQuestion(8)">未完成</van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="apply" v-show="finish_show">
        <van-button type="info" class="apply_title" @click="apply()">{{ applyStatus }}调研费用</van-button>
      </div>
      <van-popup v-model="show">
        <div class="pop_user">
          <div class="pop_title">申请信息</div>
          <van-field
            v-model="identity_id"
            label-align="left"
            left-icon="http://wsl-cdn.mymeeting.com.cn/1560059755915_cart_id.png"
            label="身份证号"
            placeholder="请填写身份证号信息"
            error-message
          />
          <van-field
            v-model="bank_card"
            label-align="left"
            left-icon="http://wsl-cdn.mymeeting.com.cn/1560059690770_card.png"
            label="银行卡号"
            placeholder="请填写银行卡号信息"
            error-message
          />
           <van-field
            v-model="bank_card_2"
            label-align="left"
            left-icon="http://wsl-cdn.mymeeting.com.cn/1560059690770_card.png"
            label="银行卡号"
            placeholder="请再次填写银行卡号"
            error-message
          />
          <van-field
            v-model="bank_name"
            label-align="left"
            left-icon="http://wsl-cdn.mymeeting.com.cn/1560059706517_bank_name.png"
            label="开户银行"
            placeholder="例:建行北京上地支行"
            error-message
          />
          <div class="apply">
            <van-button type="info" class="apply_title" @click="applyUser()">提交</van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api from '@/config/api.js'
import Cookies from 'js-cookie'
import { setTimeout } from 'timers'

export default {
  name: 'ResearchList',
  data () {
    return {
      identity_id: '',
      bank_card_2: '',
      bank_card: '',
      bank_name: '',
      show: false,
      q1_show: false,
      q2_show: false,
      q3_show: false,
      q4_show: false,
      q5_show: false,
      q6_show: false,
      q7_show: false,
      q8_show: false,
      finish_show: true, // 完成全部答题才可以申请
      length: 0,
      show_flg: false,
      applyStatus: '申请',
      finish: false
    }
  },

  methods: {
    // 申请调研费用
    apply () {
      if (this.length != 8 && !this.finish) {
        this.customAlert('请完成全部套调研再申请')
        return
      }
      this.show = true
      // 获取用户信息
    },
    // 获取用户信息
    getUserInfo () {
      // 获取用户信息
      let data = {}
      data.openid = Cookies.get('openid')
      Http.post(api.getUserInfo, data).then((response) => {
        if (response.code == 1) {
          const data = response.data
          this.identity_id = data.identity_id
          this.bank_card_2 = this.bank_card = data.bank_card
          this.bank_name = data.bank_name
          if (data.pay1) {
            this.applyStatus = data.pay2
          } else {
            // 查看是否申请支付
            this.applyStatus = data.apply2 == 1 ? '申请' : '已申请'
          }
        } else {
          // 发送失败
          // this.customAlert('获取失败')
          return false
        }
      })
    },
    // 弹框
    customAlert (msg) {
      this.$dialog.alert({
        message: msg
      })
    },

    checkBankno (bankno) {
      let a = bankno.replace(/[ ]/g, '')
      a = a.trim()
      const re = /^[0-9]+$/
      console.log(a)
      if (re.test(a)) {
        return true
      } else {
        return false
      }
    },
    isChinese (temp) {
      var re = /^[\u4e00-\u9fa5]+$/
      if (re.test(temp)) {
        return true
      } else {
        return false
      }
    },
    // 提交银行信息和银行卡信息
    applyUser () {
      this.identity_id = this.identity_id.trim()
      this.bank_card_2 = this.bank_card_2.trim()
      this.bank_card = this.bank_card.trim()
      this.bank_name = this.bank_name.trim()
      if (this.identity_id.length == 0) {
        this.customAlert('身份证号码不为空')
        return false
      }

      if (this.bank_card.length == 0) {
        this.customAlert('银行卡号不为空')
        return false
      }

      if (this.bank_name.length == 0) {
        this.customAlert('开户银行不为空')
        return false
      }
      if (this.bank_card != this.bank_card_2) {
        this.customAlert('两次银行卡号不一致')
        return false
      }
      if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(this.identity_id))) {
        this.customAlert('身份证号码格式错误')
        return false
      }
      if (!this.checkBankno(this.bank_card)) {
        this.customAlert('银行卡号不对')
        return false
      }
      if (!this.isChinese(this.bank_name)) {
        this.customAlert('开户银行不对')
        return false
      }
      let data = {}
      data.identity_id = this.identity_id
      data.bank_card = this.bank_card
      data.bank_name = this.bank_name
      data.openid = Cookies.get('openid')
      data.uid = Cookies.get('uid')
      data.periods = 2
      Http.post(api.applyPly, data).then((response) => {
        if (response.code == 1) {
          // 提示申请成功
          this.show = false
          this.applyStatus = '已申请'
          this.customAlert('申请成功')
        } else {
          // 发送失败
          this.customAlert('申请失败')
          return false
        }
      })
    },
    // 答题去
    goQuestion (num) {
      const periods = 2 // 第一期
      switch (num) {
        case 1:
          this.$router.push({ name: 'Question1', query: { periods: periods } })
          break
        case 2:
          this.$router.push({ name: 'Question2', query: { periods: periods } })
          break
        case 3:
          this.$router.push({ name: 'Question3', query: { periods: periods } })
          break
        case 4:
          this.$router.push({ name: 'Question4', query: { periods: periods } })
          break
        case 5:
          this.$router.push({ name: 'Question5', query: { periods: periods } })
          break
        case 6:
          this.$router.push({ name: 'Question6', query: { periods: periods } })
          break
        case 7:
          this.$router.push({ name: 'Question7', query: { periods: periods } })
          break
        case 8:
          this.$router.push({ name: 'Question8', query: { periods: periods } })
          break
        default:
          break
      }
    },
    // 获取用户答题情况
    getUserAnswer () {
      // 提交数据
      let data = {}
      data.periods = 2
      data.uid = Cookies.get('uid')
      Http.post(api.getUserAnswer, data).then(response => {
        this.show_flg = true
        if (response.code == 1) {
          const answer = response.data
          if (answer.includes(1)) {
            this.q1_show = true
          }
          if (answer.includes(2)) {
            this.q2_show = true
          }
          if (answer.includes(3)) {
            this.q3_show = true
          }
          if (answer.includes(4)) {
            this.q4_show = true
          }
          if (answer.includes(5)) {
            this.q5_show = true
          }
          if (answer.includes(6)) {
            this.q6_show = true
          }
          if (answer.includes(7)) {
            this.q7_show = true
          }
          if (answer.includes(8)) {
            this.q8_show = true
          }
          this.length = answer.length

          if (answer.includes(1) && answer.includes(2) && answer.includes(3) && answer.includes(4) && answer.includes(5) && answer.includes(6) && answer.includes(7) && answer.includes(8)) {
            this.finish = true
          }

          return false
        } else {
          return false
        }
      })
    }
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    this.getUserAnswer()
    this.getUserInfo()
  }
}
</script>

<style lang="less">
@import "../style/var";
.researchList {
  .header {
    img {
      width: 100%;
      display: block;
    }
  }
  .van-popup--center {
    width: 80%;
  }
  .pop_title {
    font-size: 20px;
    margin: 20px;
    text-align: center;
  }
  .van-button--info {
    color: #fff;
    background-color: #50a0f1;
    border: 1px solid #1989fa;
  }
  van-button--default {
    color: #323233;
    background-color: #5beae4;
    border: 1px solid #ebedf0;
  }
  .body {
    //margin-top: 1rem;
    .title {
      text-align: left;
      font-size: 16px;
      color: @black;
      margin-top: 24px;
      margin-left: 24px;
      &_title {
        font-size: @font-size-18;
      }
      &_date {
        font-size: @font-size-12;
        color: @gray-dark;
        margin-top: @margin-top-12;
      }
    }
    .list-wai {
      border-bottom: @border-bottom;
      // padding: .1rem .25rem;
      overflow: hidden;
      .list {
        margin: 6px;
        border-radius: 0.4rem;
        // .van-row {
        //   margin : 12px;
        // }
        .list_icon {
          // width: 48px;
          // height: 48px;
          // margin-top: 8px;
          // border-radius: 4em;
          // background: #00f7a4;
          img {
            margin-left: 10px;
            width: 24px;
          }
        }
        .list_icon2 {
          // width: 48px;
          // height: 48px;
          // margin-top: 8px;
          // border-radius: 4em;
          // background: #c3ef50;
          img {
            margin-left: 10px;
            width: 24px;
          }
        }
        .list_title {
          text-align: left;
          margin-top: 16px;
          font-size: 20px;
          margin-left: 12px;
        }
        .list_status {
          //font-size: @font-size-16;
          width: 48px;
          margin-top: 6px;
          float: right;
          img {
            width: 24px;
          }
        }
        .list_status_go {
          //font-size: @font-size-16;
          float: right;
        }
      }
      .background-color-1 {
        //  background-color : @yellow;
        border-radius: 0.05rem;
      }
      .background-color-2 {
        background-color: @green;
        border-radius: 0.05rem;
      }
      .background-color-3 {
        background-color: @blue;
        border-radius: 0.05rem;
      }
    }
    .apply {
      text-align: center;
      &_title {
        font-size: @font-size-18;
        width: 50%;
        color: #007bf7;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ResearchList2.vue